import React, { useEffect } from "react";
import AOS from "aos";
import "./index.scss";

export const MartleyNutshell2 = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      mirror: true,
    });
  }, []);
  return (
    <div className="martleyNutshell2">
      <div className="component">
        <div
          className="inner-wrap"
          data-aos="fade-up"
          data-aos-offset="-200"
          data-aos-duration="700"
        >
          <div className="text">
            <h4>
              Every day, a business does great work and still loses the deal.
              Not because the work was weaker. Because the{" "}
              <strong>brand looked smaller</strong> than the business actually is.
              <br />
              <br />
              That&apos;s the exact gap Martley Strategy was built to close. Brand
              strategy, marketing, design, and web development for small
              businesses and service businesses ready to{" "}
              <strong>look like the company they&apos;ve already become</strong>, not
              the one they started as.
              <br />
              <br />
              It started small, working directly with small business owners and
              service providers, close enough to see the real problem every
              time:{" "}
              <strong>
                the service was excellent, the branding hadn&apos;t caught up.
              </strong>{" "}
              That&apos;s still the starting point on every project today, whether
              it&apos;s a solo operator building a brand from nothing or an
              established business overdue for a refresh.
              <br />
              <br />
              Marketing gets a business found by the right people. Brand
              identity and web design make sure what they find actually holds
              up, a site that loads fast, a brand that looks the same on a
              truck door as it does on a proposal,{" "}
              <strong>consistency that reads as credibility</strong> before a single
              word is spoken.
              <br />
              <br />
              Every project runs through a global team, senior talent working
              alongside Martley&apos;s core team so the work moves fast without
              cutting corners, informed by{" "}
              <strong>what&apos;s actually working across markets</strong>, not
              guesswork.
              <br />
              <br />
              The businesses that come to Martley aren&apos;t looking for a redesign.
              They&apos;re looking for the moment a client stops asking{" "}
              <strong>&quot;are you legit&quot;</strong> and starts asking{" "}
              <strong>&quot;when can you start.&quot;</strong>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};